<div class="d-flex align-items-center">
  <a
    class="text-ul text-ellipsis"
    (click)="onClick('GROUP')"
    nz-tooltip
    [nzTooltipTitle]="params.value"
    >{{ params.value}}</a>
    <span *ngIf="!params.value"> - </span>
</div>
